import { canSwapMods } from "./selectors/canSwapMods";
import { getVariationDraft } from "./selectors/getVariationDraft";
import { getVariationDraftImage } from "./selectors/getVariationDraftImage";
import { getVariationDraftInjection } from "./selectors/getVariationDraftInjection";
import { getVariationDraftText } from "./selectors/getVariationDraftText";
import { initDraft } from "./thunks/initDraft";
import { selectElement } from "./thunks/selectElement";
import { selectElements } from "./thunks/selectElements";
import { selectInjection } from "./thunks/selectInjection";
import { swapDraft } from "./thunks/swapDraft";
import { basicModSlice } from "./slice";
import { getVariationDraftLayout } from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraftLayout";

const { _initDraft, ...publicActions } = basicModSlice.actions;

export const BasicModAction = {
  ...publicActions,
  initDraft,
  selectElement,
  selectElements,
  selectInjection,
  swapDraft,
};

export const BasicModSelector = {
  ...basicModSlice.selectors,
  getVariationDraft,
  getVariationDraftText,
  getVariationDraftImage,
  getVariationDraftHTML: getVariationDraftLayout,
  getVariationDraftInjection,
  canSwapMods,
};
